import { useMemo } from 'react';
import { get } from 'lodash';
import { ChipProps } from '@mui/material';

import { RouteStateTypes } from '~globals/types/enums';

interface RouteStateInfoItem {
  description: string;
  color: NonNullable<ChipProps['color']>;
  tooltipMessage: string;
}

type RouteStateList = {
  [state in RouteStateTypes]: RouteStateInfoItem;
};

export const useRouteStateInfo = (
  stateId: RouteStateTypes,
  isTemplate: boolean,
): RouteStateInfoItem => {
  const stateList = useMemo<RouteStateList>(
    () => ({
      [RouteStateTypes.New]: {
        description: 'A Asignar',
        color: 'secondary',
        tooltipMessage: 'Ruta sin chofer asignado.',
      },
      [RouteStateTypes.Assigned]: {
        description: 'A Confirmar',
        color: 'secondary',
        tooltipMessage: 'Aguardando confirmación de asignación de chofer.',
      },
      [RouteStateTypes.Approve]: {
        description: 'A Realizar',
        color: 'info',
        tooltipMessage: 'Aguardando que se comience el recorrido.',
      },
      [RouteStateTypes.Rejected]: {
        description: 'Rechazada',
        color: 'error',
        tooltipMessage: 'El chofer asignado rechazó la ruta.',
      },
      [RouteStateTypes.InProgress]: {
        description: 'En Tránsito',
        color: 'primary',
        tooltipMessage: 'La ruta se encuentra en camino.',
      },
      [RouteStateTypes.Finalized]: {
        description: 'Completada',
        color: 'success',
        tooltipMessage: 'La ruta ha sido finalizada.',
      },
      [RouteStateTypes.Expired]: {
        description: 'Expirada',
        color: 'tertiary',
        tooltipMessage: 'Ruta abortada por superar el tiempo de espera máximo.',
      },
    }),
    [],
  );

  const currentInfo = useMemo<RouteStateInfoItem>(() => {
    if (isTemplate) {
      return {
        description: 'Plantilla',
        color: 'secondary',
        tooltipMessage: 'Plantilla',
      };
    }

    return get(stateList, stateId);
  }, [isTemplate, stateId, stateList]);

  return currentInfo;
};
